import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, useMediaQuery } from "@mui/material"
import { t } from "i18next";
import { useTheme } from "@mui/material/styles";

const CategoryValidationDialog = (props: any) => {


  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <div className="confirmationDialog" dir="currentLanguage==='English'?'ltr':'rtl'">
        <Dialog
          fullScreen={fullScreen}
          open={props.open}
          onClose={props.handleClose}
          aria-labelledby="responsive-dialog-title"
          className="dialog-box"
        >
          <DialogTitle id="responsive-dialog-title">
            {"Category Updated"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {/* {props.message} */}
              <div dangerouslySetInnerHTML={{ __html: props.message }} />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button className="btn-no" autoFocus onClick={props.onClose}>
              {t('Cancel')}
            </Button>
            <Button className="btn-yes" onClick={props.update} autoFocus>
              {t('Agree')}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  )

}

export default CategoryValidationDialog;